import { render, staticRenderFns } from "./Ui.vue?vue&type=template&id=686f8f90&lang=pug&"
import script from "./Ui.vue?vue&type=script&lang=js&"
export * from "./Ui.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports